import React from 'react';

const RefundPolicy = () => {
    return (
        <div className="sa-modal-body">
            <div className="sa-terms-content">
                <h2>İSKENDERUN BELEDİYESİ SPOR MÜDÜRLÜĞÜ</h2>
                <h3>İPTAL VE PARA İADE POLİTİKASI</h3>

                <h4>1) İptal ve İade Süresi</h4>
                <p>Randevuya ilişkin iptal/iade talebi, randevu tarihinden itibaren ve/veya randevu kullanım zamanına bağlı olarak en geç 30 gün içinde yapılmalıdır.</p>
                <p>İade değerlendirmesi; randevunun kullanılıp kullanılmadığı, iptal talebinin zamanı ve varsa belgelendirilen durumlar dikkate alınarak yapılır.</p>

                <h4>2) İptal/İade Talebi İçin Gerekli Bilgiler</h4>
                <p>İptal veya iade talebinizin değerlendirilebilmesi için aşağıdaki bilgiler gereklidir:</p>
                <p>• Randevu sahibi ad-soyad / kurum adı<br />
                    • T.C. kimlik no (kurumsal başvurularda vergi no opsiyonel)<br />
                    • Randevu tarihi, saati ve tesis/saha adı<br />
                    • Ödeme dekontu veya ödeme kanıtı (varsa)<br />
                    • İptal gerekçesi ve varsa destekleyici belgeler</p>

                <h4>3) Başvuru ve Süreç</h4>
                <p>İptal/iade talebinizi başlatmak için Spor Müdürlüğü ile iletişime geçebilirsiniz:</p>
                <p><strong>E-posta:</strong> bilgiotomasyon@iskenderun.bel.tr<br />
                    <strong>Telefon:</strong> 444 19 39<br />
                    <strong>Adres:</strong> Yenişehir, Mareşal Fevzi Çakmak Cd. No:48, 31200 İskenderun/Hatay</p>
                <p>Talebiniz uygun bulunduğunda, izlenecek adımlar tarafınıza yazılı olarak bildirilecektir.</p>
                <p>Önceden başvuru yapılmadan yapılan işlemler ve/veya sistem dışı talepler değerlendirmeye alınmayabilir.</p>

                <h4>4) Hatalı İşlem, Eksik Hizmet ve Sorun Bildirimi</h4>
                <p>Lütfen randevu bilgilerinizin doğruluğunu ve tesis kullanım koşullarını kontrol ediniz.</p>
                <p>Aşağıdaki durumlarda gecikmeksizin Spor Müdürlüğü ile iletişime geçiniz:</p>
                <p>• Yanlış tarih/saat/tesis bilgisi ile randevu oluşturulması<br />
                    • Sistem kaynaklı ücret tahsilatı veya kayıt hatası<br />
                    • Tesisin hizmete kapalı olması, saha kullanımını engelleyen arıza vb. durumlar<br />
                    • Yanlış bilgilendirme veya eksik hizmet</p>
                <p>Bildiriminiz incelenerek gerekli düzeltme/çözüm sağlanır.</p>

                <h4>5) İade Kapsamı Dışındaki Durumlar (İstisnalar)</h4>
                <p>Aşağıdaki hallerde iade yapılamayabilir:</p>
                <p>• Randevunun kullanılmış olması (tesis kullanımının gerçekleşmesi)<br />
                    • Randevu saatine çok kısa süre kala yapılan iptaller (mevzuat/kurum uygulamasına göre)<br />
                    • Kampanya/indirimli ücretlerle sunulan bazı randevu türleri (varsa)<br />
                    • Hediye/kupon ile oluşturulan işlemler (varsa)<br />
                    • Üçüncü kişiler tarafından usulsüz kullanım veya yanlış beyan</p>
                <p><strong>Not:</strong> İstisnalar, İskenderun Belediyesi'nin ilgili yönerge/mevzuat hükümleri çerçevesinde uygulanır.</p>

                <h4>6) Randevu Değişikliği (Tarih/Saat/Tesis)</h4>
                <p>İstediğiniz tarih veya saat değişikliği için en hızlı yöntem:</p>
                <p>• Mevcut randevunuzu iptal talebine konu etmek<br />
                    • Uygunluk durumuna göre yeni randevuyu ayrıca oluşturmak olabilir</p>
                <p>Değişiklik talepleri, tesis yoğunluğu ve uygunluk durumuna göre değerlendirilir.</p>

                <h4>7) Ücret İadeleri</h4>
                <p>İade talebiniz alındıktan sonra, randevu durumu ve belgeler incelenir.</p>
                <p>İade uygun görülürse, ücret ödemenin yapıldığı yöntem üzerinden iade edilir.</p>
                <p>Banka/kredi kartı süreçlerine bağlı olarak iadenin hesaba yansıması birkaç iş günü sürebilir.</p>

                <h4>İLETİŞİM</h4>
                <p><strong>İskenderun Belediyesi Spor Müdürlüğü</strong><br />
                    E-posta: bilgiotomasyon@iskenderun.bel.tr<br />
                    Telefon: 444 19 39<br />
                    Adres: Yenişehir, Mareşal Fevzi Çakmak Cd. No:48, 31200 İskenderun/Hatay</p>
            </div>
        </div>
    );
};

export default RefundPolicy;
